import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import DailyReports from './DailyReports';
import MonthlyReports from './MonthlyReports';

// Example components for each tab
const Tab1Content = () => <div><DailyReports /></div>;
const Tab2Content = () => <div><MonthlyReports /></div>;

const Reports = () => {
  // State to track the active tab
  const [activeTab, setActiveTab] = useState(1);

  // Function to change the active tab
  const handleTabClick = (e, tabIndex) => {
    e.preventDefault();
    setActiveTab(tabIndex);
  };

  return (
    <div className="container-fluid Container2 p-3 p-md-4">
      <div className="common-box-shadow common-bg-white common-br-3px overflow-hidden">
        
        {/* Header Title Section */}
        <div className="heading-div border-bottom px-4 pt-3 pb-2 bg-light">
          <h4 className="m-0 fw-bold text-dark">Reports Dashboard</h4>
          <p className="text-muted small mb-0">View and analyze your daily and monthly performance metrics</p>
        </div>

        {/* Tab Navigation */}
        <div className="px-4 pt-3 border-bottom bg-white">
          <ul className="nav nav-tabs tab-ul border-0 gap-2">
            <li className="nav-item">
              <button
                type="button"
                className={`nav-link px-4 py-2 border-0 fw-semibold rounded-top ${
                  activeTab === 1 ? 'Activ-tab' : 'tab text-secondary'
                }`}
                onClick={(e) => handleTabClick(e, 1)}
                style={{
                  transition: 'all 0.2s ease-in-out',
                  cursor: 'pointer'
                }}
              >
                Daily Report
              </button>
            </li>
            <li className="nav-item">
              <button
                type="button"
                className={`nav-link px-4 py-2 border-0 fw-semibold rounded-top ${
                  activeTab === 2 ? 'Activ-tab' : 'tab text-secondary'
                }`}
                onClick={(e) => handleTabClick(e, 2)}
                style={{
                  transition: 'all 0.2s ease-in-out',
                  cursor: 'pointer'
                }}
              >
                Monthly Report
              </button>
            </li>
          </ul>
        </div>

        {/* Tab Content Body */}
        <div className="tab-content p-4">
          {activeTab === 1 && (
            <div className="tab-pane fade show active">
              <Tab1Content />
            </div>
          )}
          {activeTab === 2 && (
            <div className="tab-pane fade show active">
              <Tab2Content />
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default Reports;